import { axiosInstance, axiosFileBlob, live_instance } from "../instance";

// 列表查询
export const getMediaListApi = (params) => {
    const { userId, pageNo, pageSize, sortType, sortByField, uploadStartTime, uploadEndTime, fileType, fileName, status, cpspid, serverType } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/media/page`,
        params: { userId, pageNo, pageSize, sortType, sortByField, uploadStartTime, uploadEndTime, fileType, fileName, status, cpspid, serverType },
        noRepetition: true,
    });
}

// 新增媒体，返回id再上传
export const addMediaApi = (data) => {
    return live_instance({
        method: 'post',
        url: `/vod-transcode/media`,
        data,
        type: 'json'
    });
}

// 上传媒体文件
export const uploadMediaApi = (params, data) => {
    return live_instance({
        method: 'post',
        url: `/vod-transcode/media/file/upload`,
        data,
        params,
        type: 'upload', duration: 5000, timeout: 1800000,
    })
}



// 获取用户名
export const getMediaUserNameApi = () => {
    return live_instance ({
        method: 'get',
        url: `/vod-transcode/media/username`,
    })
}

// 合并
export const mediaMergeApi = (data) => {
    const { identifier } = data;
    return axiosInstance({
        method: 'post',
        url: `/api/mediaAsset/merge`,
        data: { identifier },
        // type: 'json'
    });
}

// 根据id获取状态
export const getStatusByIdsApi = (params) => {
    const { ids } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/media/status`,
        params: { idList: ids },
        arrayFormat: 'repeat',
        type: 'json'
    });
}

// 获取上传用户列表
export const getUserNameListApi = (params?) => {
    return axiosInstance({
        method: 'get',
        url: `/api/mediaAsset/getUserNameList`,
        params
    });
}

// 文件信息入库
export const insertMediaApi = (data) => {
    const { sourceId, programType, fileName, fileType, fileSize, fileIdentifier, isReUpload, id, cpspid, userId } = data;
    return axiosInstance({
        method: 'post',
        url: `/api/mediaAsset/insertMedia`,
        data: { sourceId, programType, fileName, fileType, fileSize, fileIdentifier, isReUpload, id, cpspid, userId },
        // type: 'json'
    });
}

// 更新媒体状态
export const updateMediaStatusApi = (data) => {
    return live_instance({
        method: 'put',
        url: '/vod-transcode/media/status',
        data,
        type: 'json'
    })
}



// 删除上传文件
export const deleteFileApi = (data) => {
    const { idList } = data;
    return live_instance({
        method: 'delete',
        url: `/vod-transcode/media`,
        params: { idList },
        arrayFormat: 'repeat',
        // type: 'json'
    });
}

// 上传取消
export const uploadCancelApi = (data) => {
    return live_instance({
        method: 'put',
        url: `/vod-transcode/media/status`,
        data,
        type: 'json'
    });
}

// 上传完成
export const uploadEndApi = (data) => {
    const { id, filePath } = data;
    return axiosInstance({
        method: 'post',
        url: `/api/mediaAsset/uploadEnd`,
        data: { id, filePath },
        // type: 'json'
    });
}

// 校验文件是否重复上传
export const isUploadingApi = (params) => {
    const { identifier, userId } = params;
    return axiosInstance({
        method: 'get',
        url: `/api/mediaAsset/isUploading`,
        params: { identifier, userId },
    });
}

// 获取上传文件详情
export const getMediaDetailApi = (params) => {
    const { id } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/media/info`,
        params: { id },
    });
}

// 导出已上传
export const exportMediaApi = (data) => {
    const { ids, userId, cpspid, serverType } = data;
    return axiosFileBlob({
        method: 'post',
        url: `/api/mediaAsset/export`,
        data: { ids, userId, cpspid, serverType },
        arrayFormat: 'repeat',
    });
}

// 获取文件类型下拉数据
export const getFileTypeListApi = (serverType) => {
    return live_instance({
        method: 'get',
        url: `/vod-transcode/media/file/type/list`,
        params: {serverType}
    });
}

// add to添加影片更新节目信息
export const updateProgramApi = (data) => {
    const { id, programId, programName, sourceId } = data;
    return axiosInstance({
        method: 'post',
        url: `/api/mediaAsset/updateProgram`,
        data: { id, programId, programName, sourceId },
    });
}

// 文件转码
export const fileTranscodeApi = (data) => {
    const { transcodeUrl, fileIdentifier } = data;
    return live_instance({
        method: 'post',
        url: `/vod-transcode/media/file/transcode`,
        data: { transcodeUrl, fileIdentifier },
        // type: 'json'
    });
}

/**======================================== 模板管理 ========================================================= */

// 新增模板
export const addTemplateApi = (data) => {
    const { outputParamList, modeDescribe, name } = data;
    return live_instance({
        method: 'post',
        url: `/vod-transcode/template`,
        data: { outputParamList, modeDescribe, name },
        type: 'json'
    });
}

// 导入转码模板
export const importTemplateApi = (data) => {
    return live_instance({
        method: 'post',
        url: `/vod-transcode/template/import`,
        data,
        type: 'upload',
        timeout: 1800000,
    });
}

// 获取模板管理列表
export const getTemplateListApi = (params) => {
    const { pageNo, pageSize, sortType, sortField, name } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/template/page`,
        params: { pageNo, pageSize, sortType, sortField, name },
        noRepetition: true,
    });
}

// 编辑模板
export const editTemplateApi = (data) => {
    const { id, outputParamList, modeDescribe, name } = data;
    return live_instance({
        method: 'put',
        url: `/vod-transcode/template`,
        data: { id, outputParamList, modeDescribe, name },
        type: 'json'
    });
}

// 删除模板
export const deleteTemplateApi = (data) => {
    const { idList } = data;
    return live_instance({
        method: 'delete',
        url: `/vod-transcode/template`,
        params: { idList },
        // type: 'json'
    });
}

/**======================================== 日志管理 ========================================================= */

// 获取日志列表
export const getLogListApi = (params) => {
    const { pageNo, pageSize, sortType, sortField, name } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/log/page`,
        params: { pageNo, pageSize, sortType, sortField, name },
        noRepetition: true,
    });
}

// 查询日志内容
export const getLogContentApi = (params) => {
    const { logUrl } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/log/content`,
        params: { logUrl },
        noRepetition: true,
    });
}

/**======================================== S3存储管理 ========================================================= */

// 获取区域列表
export const getAreaListApi = () => {
    return axiosInstance({
        method: 'get',
        url: `/api/mediaAsset/getAreaList`,
        noRepetition: true,
    });
}

// 获取S3存储管理列表
export const getS3ListApi = (params) => live_instance({method: 'get', url: `/vod-transcode/server-config/page`, params})

// 检查是否打开自动转码任务
export const checkAutoTranscodeTaskApi = (params) => live_instance({method: 'get', url: `/vod-transcode/task-control/check`, params})

// 获取目录列表
export const getFolderListApi = (params) => live_instance({method: 'get', url: `/vod-transcode/server-config/folder/list`, params, timeout: 1800000,})

// 新增S3存储配置
export const addConfigApi = (data) => live_instance({method: 'post', url: `/vod-transcode/server-config`, data, type:'json', timeout: 1800000 })

// 编辑S3存储配置
export const editConfigApi = (data) => live_instance({method: 'put', url: `/vod-transcode/server-config`, data, type:'json', timeout: 1800000 })

// 删除S3存储配置
export const deleteConfigApi = (params) => live_instance({method: 'delete', url: `/vod-transcode/server-config`, params,  })

// 导入S3存储配置
export const importConfigApi = (data) => live_instance({method: 'post', url: `/vod-transcode/server-config/import`, data, type: 'upload', timeout: 1800000 })

// 导出转码任务列表
export const exportTaskListApi = (params) => live_instance({method: 'get', url: `/vod-transcode/task/export`, params, responseType: 'blob' })

/**======================================== 任务管理 ========================================================= */

// 获取任务列表
export const getTaskListApi = (params) => {
    return live_instance({
        method: 'get',
        url: `/vod-transcode/task/page`,
        params,
        noRepetition: true,
    });
}

// 查询服务列表
export const getServerListApi = (serverType) => {
    return live_instance({
        method: 'get',
        url: `/vod-transcode/server-config/list`,
        noRepetition: true,
        params: {serverType}
    });
}

// 获取模板列表
export const getModeListApi = () => {
    return live_instance({
        method: 'get',
        url: `/vod-transcode/template/list`,
        noRepetition: true,
    })
}

// 任务管理获取日志
export const getTaskLogApi = (params) => {
    const { taskId } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/log/info`,
        params: { taskId },
        noRepetition: true,
    })
}

// 获取文件列表
export const getFileListApi = (params) => {
    const { serverId, path } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/server-config/file/list`,
        params: { serverId, path },
        timeout: 1800000,
        // noRepetition: true,
    });
}

// 新增任务
export const addTaskApi = (data) => {
    return live_instance({
        method: 'post',
        url: `/vod-transcode/task`,
        data,
        noRepetition: true,
        timeout: 1800000,
        type: 'json'
    });
}

// 删除任务
export const deleteTaskApi = (data) => {
    const { idList } = data;
    return live_instance({
        method: 'delete',
        url: `/vod-transcode/task`,
        params: { idList },
        arrayFormat: 'repeat',
        // type: 'json'
    });
}

/**======================================== 自动转码任务 ========================================================= */

// 获取自动转码任务列表
export const getTaskControlListApi = (params) => {
    const { pageNo, pageSize, sortType, sortField, name, startTime, endTime, status, serverType } = params;
    return live_instance({
        method: 'get',
        url: `/vod-transcode/task-control/page`,
        params: { pageNo, pageSize, sortType, sortField, name, startTime, endTime, status, serverType },
        noRepetition: true,
    });
}

// 获取转码语言列表
export const getLanguageListApi = () => {
    return live_instance({
        method: 'get',
        url: `/vod-datasource/language/list`
    })
}

// 获取国家列表
export const getCountryListApi = () => {
    return live_instance({
        method: 'get',
        url: `/vod-datasource/country`
    })
}

// 新增自动转码任务
export const addAutoTaskApi = (data) => {
    return live_instance({
        method: 'post',
        url: `/vod-transcode/task-control`,
        data,
        noRepetition: true,
        timeout: 1800000,
        type: 'json'
    });
}

// 导入自动转码任务
export const importAutoTaskApi = (data) => {
    return live_instance({
        method: 'post',
        url: `/vod-transcode/task-control/import`,
        data,
        type: 'upload',
        timeout: 1800000,
    });
}

// 删除自动转码任务
export const delTaskControlApi = (data) => {
    const { idList } = data;
    return live_instance({
        method: 'delete',
        url: `/vod-transcode/task-control`,
        params: { idList },
        arrayFormat: 'repeat',
    });
}

// 修改转码任务状态，id 用于单条操作，idList 用于批量操作
export const editStatusApi = (data) => {
    const { status, id, idList } = data;
    return live_instance({
        method: 'put',
        url: `/vod-transcode/task-control/status`,
        data: idList ? { status, idList } : { status, id },
        noRepetition: true,
        type: 'json'
    });
}

// 编辑自动转码任务
export const editTaskControlApi = (data) => {
    return live_instance({
        method: 'put',
        url: `/vod-transcode/task-control`,
        data,
        timeout: 1800000,
        type: 'json'
    });
}